import React from 'react';

import { cn } from '~/lib/utils';

export interface TextareaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  description?: string;
  error?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ description, error, className, ...props }, ref) => {
    return (
      <div>
        <textarea
          autoCapitalize='off'
          autoComplete='off'
          autoCorrect='off'
          className={cn(
            'font-greycliff-extrabold text-muted-foreground focus:outline-hidden min-h-[64px] w-full cursor-text resize-y appearance-none rounded-none border-b-2 border-solid text-lg',
            className,
          )}
          ref={ref}
          spellCheck='false'
          {...props}
        />
        {description && <div>{description}</div>}
        {error && <div className='text-red mt-2'>{error}</div>}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';
